export function snakeCaseToTitleCase(input: string): string {
  return input
    .replace(/_/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());
}
